import { normalizeRouteQuery } from '@/helpers/Route/normalizeRouteQuery';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import {
  RouteComponent,
  RouteLocationNormalized,
  RouteRecordNameGeneric,
  RouteRecordRaw,
} from 'vue-router';

export type LocalizeRouteRaw = Omit<RouteRecordRaw, 'redirect'>;

export interface LocalizedRoutes {
  de: LocalizeRouteRaw;
  en: LocalizeRouteRaw;
  fr: LocalizeRouteRaw;
  it: LocalizeRouteRaw;
}

const SEPARATOR = '-';
const VIEW_NAME_PREFIX = 'Property Valuation';

export const getRouteNameWithLanguage = (prefix: string, locale: HgSupportedLanguage) =>
  `${prefix}${SEPARATOR}${locale}`;

export const getRouteName = (name: RouteRecordNameGeneric) =>
  (name ?? '').toString().split(SEPARATOR)[0];

export const camelCaseToPascalWithSpaces = (str: string): string =>
  str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (match) => match.toUpperCase())
    .trim();

export const generateLocalizedRouteConfig = (
  localizedRoutes: LocalizedRoutes,
  component: RouteComponent,
  prefix: string,
): RouteRecordRaw[] =>
  Object.entries(localizedRoutes).map(([locale, { path, meta }]) => ({
    path,
    component,
    name: getRouteNameWithLanguage(prefix, locale as HgSupportedLanguage),
    meta: {
      locale,
      viewName: `${VIEW_NAME_PREFIX} ${camelCaseToPascalWithSpaces(prefix)} Page`,
      getLanguageSwitchLink(route: RouteLocationNormalized, language?: HgSupportedLanguage) {
        return {
          name: getRouteNameWithLanguage(prefix, language ?? HgSupportedLanguage.DE),
          query: normalizeRouteQuery(route.query),
          params: route.params,
        };
      },
      ...meta,
    },
  }));
